import axios from 'axios'

const editLifeTime = async (lifeTime) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/updateSessionConfiguration`,
      {
        timeout: lifeTime,
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      }
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export default editLifeTime
